<template>
  <div class="page">
    <div class="page__header">
      <HorisontalTabsList :tabs="tabs"></HorisontalTabsList>
      <div class="page__header_right">
        <IconButton class="button--auto button--uppercase" text="add tag" @click="modal = true">
          <IconPlusBold></IconPlusBold>
        </IconButton>
      </div>
    </div>
    <Table
      :loading="loading"
      :items="items"
      :headerItems="headerItems"
      :tableData="tableData"
      :hasMorePages="hasMorePages"
      @sortTable="sortTable"
      @clickAction="clickAction"
      @loadMore="loadMore"
    ></Table>
    <Tag
      v-if="modal"
      :modal="modal"
      :item="tag"
      @hideModal="modal = false"
      @createTag="createTag"
      @updateTag="updateTag"
      @removeTag="confirmRemoveTag"
    ></Tag>
  </div>
</template>
<script>
import HorisontalTabsList from "@/components/HorisontalTabsList.vue";
import Table from "@/components/Table.vue";
import Tag from "./Tag.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import IconPlusBold from "@/components/icons/IconPlusBold.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  components: {
    HorisontalTabsList,
    Table,
    Tag,
    IconButton,
    IconPlusBold,
  },
  data() {
    return {
      tabs: [
        {
          title: "Blogs",
          path: "/admin/content/blogs",
          key: "blog",
        },
        {
          title: "Publications",
          path: "/admin/content/publications",
          key: "editorial",
        },
        {
          title: "Tag Manager",
          path: "/admin/content/tag-manager",
          key: "tags",
        },
        {
          title: "Pages",
          path: "/admin/content/pages",
          key: "pages",
        },
      ],
      modal: false,
      tableData: {
        page: 1,
        sort: "title",
        order: "asc",
        status: "",
      },
    };
  },
  async created() {
    await this.apiGetTags(this.tableData);
    this.initialTag();
  },
  watch: {
    modal(val) {
      if (!val) {
        this.initialTag();
        this.setError(null);
      }
    },
  },
  computed: {
    ...mapGetters("tags", {
      items: "getTags",
      headerItems: "getTagsHeaders",
      loading: "getLoading",
      hasMorePages: "getHasMorePages",
      tag: "getTag",
    }),
  },
  methods: {
    ...mapActions("tags", ["apiGetTags", "apiGetTag", "apiPostTag", "apiPutTag", "apiDeleteTag"]),
    ...mapMutations("tags", ["initialTag", "setError"]),
    async sortTable({ sort, order }) {
      let data = { ...this.tableData, page: 1, sort, order };
      let success = await this.apiGetTags(data);
      if (success) {
        this.tableData = data;
      }
    },
    async loadMore() {
      if (this.hasMorePages) {
        let data = { ...this.tableData, page: this.tableData.page + 1 };
        let success = await this.apiGetTags(data);
        if (success) {
          this.tableData = data;
        }
      }
    },
    async clickAction({ key, id, item }) {
      switch (key) {
        case "edit": {
          let result = await this.apiGetTag(id);
          if (result) {
            this.modal = true;
          }
          break;
        }
        case "delete": {
          let result = await this.confirmRemoveTag(item);
          if (result) {
            this.modal = true;
          }
          break;
        }
      }
    },
    async createTag({ data }) {
      let result = await this.apiPostTag(data);
      if (result.success) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetTags(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
        this.$swal({
          title: "Tag successfully created",
          confirmButtonText: "Ok",
        });
      }
    },
    async updateTag({ data }) {
      let result = await this.apiPutTag(data);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetTags(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
        this.$swal({
          title: "Tag successfully updated",
          confirmButtonText: "Ok",
        });
      }
    },
    confirmRemoveTag(item) {
      this.$swal({
        title: `Delete ${item.title}`,
        html: "<h5>This tag will be removed <br/> everywhere it appears",
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        denyButtonText: "Delete",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.value === false) {
          this.removeTag(item.id);
        }
      });
    },
    async removeTag(id) {
      let result = await this.apiDeleteTag(id);
      if (result.success) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetTags(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
        this.$toasted.show(result.message, {
          duration: 2000,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
}
</style>
